import { useWizard } from '../../../context/WizardContext';
import { ChapterSelect } from '../../../components/wizard/ChapterSelect';
import { NavigationButtons } from '../../../components/wizard/NavigationButtons';

export function Step3Chapter() {
  const { state, toggleChapter } = useWizard();
  const chapters = state.selectedPaper?.chapters ?? [];

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-white">Select Chapters</h2>
        <p className="text-sm text-slate-500 mt-1">
          Choose one or more chapters from{' '}
          <span className="font-medium text-slate-300">
            {state.selectedSubject?.name} — {state.selectedPaper?.name}
          </span>
          . You can select multiple.
        </p>
      </div>
      <ChapterSelect
        chapters={chapters}
        selected={state.selectedChapters}
        onToggle={toggleChapter}
      />
      <NavigationButtons />
    </div>
  );
}
